import { useQuery } from '@hooks/reactQuery';

import { getOrganisationsSwitch } from '@api/organisationSwitch';

import { formatOptionsLabelWithAvatar } from '@utils/formatOptionsLabelWithAvatar';

import { IOrganisationSwitchEntity } from '@interfaces/organisation/organisations';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { refetchOptions } from '@constants/common';
import { ORGANIZATIONS_SWITCH } from '@constants/queryKeys';

interface IQueryOrganisationSwitchReturned {
	organisationsSwitch: TSelectOptionType[];
	isOrganisationsSwitchLoading: boolean;
}

export const useQueryOrganisationSwitch = (): IQueryOrganisationSwitchReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IOrganisationSwitchEntity[], any[]>({
		queryKey: [ORGANIZATIONS_SWITCH],
		queryFn: getOrganisationsSwitch,
		select: (organisations) => {
			return organisations.map(formatOptionsLabelWithAvatar);
		},
		...refetchOptions,
	});

	return {
		organisationsSwitch: data || [],
		isOrganisationsSwitchLoading: isInitialLoading,
	};
};
